import { render } from "./ChangeUserEmail.vue?vue&type=template&id=25755dbd&ts=true"
import script from "./ChangeUserEmail.vue?vue&type=script&lang=ts"
export * from "./ChangeUserEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__